import { Input } from "antd";
import styles from "./style.module.scss";
import { Rule } from "antd/es/form";
import { cloneElement, isValidElement, ReactNode, useState } from "react";

interface ISimpleInput<T> {
    Form: any;
    name?: any[] | keyof T;
    label?: string;
    hidden?: boolean;
    rules?: Rule[];
    customInput?: ReactNode;
    disabled?: boolean;
    hasFeedback?: boolean;
    valuePropName?: "checked";
    onChange?: (e: any) => void;
    onPressEnter?: () => void;
    maxLength?: number;
    spaceNoWrap?: boolean;
    placeholder?: string;
    helperText?: string;
}

export const SimpleInput = <T,>({ Form, name, label, hidden,placeholder, rules, customInput, disabled, hasFeedback, valuePropName, onChange, onPressEnter, maxLength, spaceNoWrap, helperText }: ISimpleInput<T>) => {

    const [isFocused, setIsFocused] = useState<boolean>(false);

    return (
        <>
            <span className={`${spaceNoWrap ? styles.input__nowrap : ""}`}>
                {label && <label className={`${styles.input__label}`}>
                    {label}
                    {
                        rules?.some((rule: any) => ((rule?.required === true))) && (
                            <span className={styles.input__required}> *</span>
                        )
                    }
                </label>}
            </span>

            {name ? (
                <>
                    <Form.Item<T>
                        hidden={hidden}
                        name={name}
                        rules={rules}
                        hasFeedback={hasFeedback}
                        valuePropName={valuePropName}
                        className={spaceNoWrap ? "w-100" : "m-0"}
                    >
                        {!customInput ?
                            <Input maxLength={maxLength} onChange={onChange} onPressEnter={onPressEnter} disabled={disabled} className="w-100" placeholder={placeholder} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} /> :
                            (
                              isValidElement(customInput)
                              ? cloneElement(customInput as React.ReactElement<any>, {
                                  onFocus: () => setIsFocused(true),
                                  onBlur: () => setIsFocused(false),
                                })
                              : customInput
                            )
                        }
                    </Form.Item>
                    {(helperText && isFocused) && (
                        <span className={styles.input__helper_text}>{helperText}</span>
                    )}
                </>
            ) :
                (
                    <>
                        {!customInput ?
                            <Input max={maxLength} onChange={onChange} onPressEnter={onPressEnter} disabled={disabled} className="w-100" onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(false)} /> :
                            (
                              isValidElement(customInput)
                              ? cloneElement(customInput as React.ReactElement<any>, {
                                  onFocus: () => setIsFocused(true),
                                  onBlur: () => setIsFocused(false),
                                })
                              : customInput
                            )
                        }
                        {(helperText && isFocused) && (
                            <span className={styles.input__helper_text}>{helperText}</span>
                        )}
                    </>
                )
            }
        </>
    )
}